import {initializeApp} from 'firebase/app';
import {getAnalytics, logEvent} from 'firebase/analytics';
import { getUserCredentials } from '@meprism/shared/src/services/AuthenticationService';
const firebaseConfig = {
    apiKey: "AIzaSyC6edPtwUL-IKh0b-rIC8AfTnEM15U9uFQ",
    authDomain: "meprism-dev.firebaseapp.com",
    databaseURL: "https://meprism-dev.firebaseio.com",
    projectId: "meprism-dev",
    storageBucket: "meprism-dev.firebasestorage.app",
    messagingSenderId: "460433113899",
    appId: "1:460433113899:web:e3008e840e1765089dfb6e",
    measurementId: "G-NXZZPQ4JS5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics
export const analytics = getAnalytics(app);

// Function to log events
export const logFirebaseEvent = async (
  eventName: string,
  eventParams?: Record<string, any>
) => {
  try {
    const credentials = await getUserCredentials();

    logEvent(analytics, eventName, {
      ...credentials,
      ...(eventParams || {})
    });
  } catch (error) {
    console.error("Error logging Firebase event:", error);
  }
};
